var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg91(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st4{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.53,2.39v3.08h-4.51V2.9c0,0,0.23-1.08-1.14-1.03H14.91c0,0-1.08,0.06-1.03,1.14s0,0.29,0,0.29v15.63 c0,0,0.12,0.74,1.2,0.8h11.86c0,0,1.03,0.11,1.2-1.25l-0.06-2.79h4.45v28c0,0-2.22,0.29-1.77,3.25h7.13c0,0,0.51-3.65-1.77-3.25 V2.27C36.13,2.27,34.53-0.24,32.53,2.39z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.59,
    y: 3.7,
    fill: "currentColor",
    width: 10.89,
    height: 13.92
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.86,
    y: 6.83,
    fill: "currentColor",
    width: 4.85,
    height: 7.53
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.79,
    y: 15.9,
    width: 7.98,
    height: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.79,13.39V5.01h7.98v8.38h-0.51c0,0-0.4,1.31-0.91,0h-5.1c0,0-0.43,1.11-1.03,0.09L16.79,13.39z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.12,
    y: 5.51,
    fill: "currentColor",
    width: 5.39,
    height: 0.98
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.35,
    y: 6.83,
    className: "st4",
    width: 6.89,
    height: 4.49
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.35,
    y: 12.27,
    className: "st4",
    width: 1.75,
    height: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.57,
    y: 12.27,
    className: "st4",
    width: 1.67,
    height: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.87,
    y: 11.88,
    className: "st4",
    width: 2.05,
    height: 0.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.45,
    y: 12.82,
    className: "st4",
    width: 2.67,
    height: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg91);
export default __webpack_public_path__ + "static/media/91.e60d2af3e60873e700b858eaef232fa1.svg";
export { ForwardRef as ReactComponent };